import { Routes, Route, useLocation, useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "./redux/store"
import { authentication, setLoading } from "./redux/slices/auth/authSlice"
import { clearMessages, setPage } from "./redux/slices/messages/messagesSlice"
import { getPovSubscription } from "@/redux/slices/payments/paymentsSlices"
import Header from "./components/Header/Header"
import SignUpPage from "./pages/Auth/SignUpPage"
import LoginPage from "./pages/Auth/LoginPage"
import ForgotPasswordPage from "./pages/Auth/ForgotPasswordPage"
import LoginWhatsAppPage from "./pages/Auth/LoginWhatsAppPage"
import Preloader from "./components/utils/Preloader/Preloader"
import Loader from "@/Loader"
import PublicRoute from "./components/utils/PublicRoute"
import PrivateRoute from "./components/utils/PrivateRoute"
import CircularProgress from "@mui/material/CircularProgress"

// import MyInvitationsDetail from "./pages/NewCreateEventF/MyInvitationsDetail"
import RegisterPage from "./pages/Register/RegisterPage"
import ChangePasswordPage from "./pages/Auth/ChangePasswordPage"
import Message from "./pages/Auth/Message"
import WhoopsPage from "./pages/Auth/WhoopsPage"
import SuccessMessage from "./pages/NewCreateEventF/SuccessMessage"
////new pgaes
import WelcomeHome from "./pages/WelcomeHome"
import MyInvitations from "./pages/MyInvitations/MyInvitations"
import ScannedInvitation from "./pages/MyInvitations/ScannedInvitations"
import InviteDetail from "./pages/MyInvitations/InviteDetail"
import EditInvite from "./pages/editInvite/EditInvite"
import AddInvite from "./pages/addInvite/addInvite"
import AddInviteHome from "./pages/addInvite/addInviteHome"
import ProfilePage from "./pages/Profile/ProfilePage"
import NoInviteHome from "./pages/MyInvitations/NoInviteHome"
import Purchase from "./pages/Purchase/Purchase"
import { getBalance } from "@/redux/slices/balance/balanceSlice"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const App = () => {
  const location = useLocation()
  const { isLoading, email, phone, first_name, last_name } = useAppSelector(
    (state) => state?.auth,
  )
  const { open_hash } = useAppSelector((state) => state.events)
  const dispatch = useAppDispatch()
  const [isMessages, setIsMessages] = useState<boolean>(false)
  const { accessToken } = useAppSelector((state) => state.auth)
  const navigate = useNavigate()
  const [step, setStep] = useState(1)

  useEffect(() => {
    if (!isLoading)
      dispatch(getPovSubscription(email ? email : phone ? phone : "")).then(
        (data) => {
          console.log("data-data", data)
        },
      )
  }, [dispatch])
  ///dpendance location, location?.pathname, removed
  useEffect(() => {
    const token = localStorage.getItem("token") || ""
    if (token) {
      dispatch(setLoading())
      dispatch(authentication(null))
        .then((data) => {})
        .catch((error) => {})
    }

    if (location.pathname === "/messages") {
      setIsMessages(true)
    } else {
      dispatch(clearMessages())
      dispatch(setPage(1))
      setIsMessages(false)
    }
  }, [dispatch])
  ///dependancy location removed
  // useEffect(() => {
  //   const token = localStorage.getItem("token") || ""
  //   if (
  //     !token &&
  //     location.pathname.split("/")[1] !== "register" &&
  //     location.pathname !== "/auth/password"
  //   ) {
  //     navigate("/welcome")
  //   }
  // }, [accessToken])
  useEffect(() => {
    dispatch(getBalance()).then((data) => {})
  }, [location])
  return (
    <div className="wrapper">
      {isLoading && (
        <>
          {/* <Preloader /> */}
          {/* <Loader /> */}
        </>
      )}

      <Header />

      <main
        className={`main py-sm-6 py-4 ${isMessages ? "main-messages" : ""}`}
      >
        <Routes>
          {/* new ones */}

          <Route element={<PrivateRoute />}>
            <Route path="/" element={<MyInvitations />} />
            <Route
              path="/scanned-guests/:event_id"
              element={<ScannedInvitation />}
            />

            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/purchase" element={<Purchase />} />
            <Route
              path="/invite-details/:event_id"
              element={<InviteDetail />}
            />
            <Route path="/invite-edit/:event_id" element={<EditInvite />} />
            <Route path="/add-guests/:event_id" element={<EditInvite />} />

            <Route path="/no-invite" element={<NoInviteHome />} />
            <Route path="/add-invite" element={<AddInviteHome />} />
          </Route>

          {/* public route */}
          <Route element={<PublicRoute />}>
            <Route path="/signup" element={<SignUpPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/whatsapp" element={<LoginWhatsAppPage />} />
            <Route path="/welcome" element={<WelcomeHome />} />
          </Route>

          {/* new ones */}

          <Route
            path="/FailedMessage"
            element={
              <SuccessMessage setStep={setStep} phoneNumber={"0946951726"} />
            }
          />

          <Route element={<PrivateRoute />}>
            <Route path="/auth/password" element={<ChangePasswordPage />} />
            <Route path="/register/:event_hash" element={<RegisterPage />} />
            <Route path="/password-success" element={<Message />} />
            <Route path="/password-failed" element={<WhoopsPage />} />
            <Route
              path="*"
              element={
                <div
                  style={{
                    height: "400px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Not found
                </div>
              }
            />
          </Route>
          <Route
            path="*"
            element={
              <div
                style={{
                  height: "400px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Not found
              </div>
            }
          />
        </Routes>
      </main>
      <ToastContainer
        style={{ width: "90%", maxWidth: "400px", fontSize: "18px" }}
      />
    </div>
  )
}

export default App
